/*!
=========================================================
* 経路図編集
=========================================================
*/
import React, {useEffect} from "react";
// reactstrap components
import {Card, CardHeader, CardTitle, CardBody, Col, Row} from "reactstrap";
// style route map
import '../../assets/scss/route-map.scss';

import GoogleMapPolygon from "./GoogleMapPolygon";

function Edit() {

    /* タイトルを設定 */
    const setTitle = () => {
        return '経路図編集';
    }

    /* 題名 */
    useEffect(() => {
        let isMounted = true;

        if ( isMounted ) {
            document.title = setTitle();
        }

        return () => { isMounted = false };
    }, []);

    return (
        <>
            <div className="content route-map">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h3">
                                    {setTitle()}
                                </CardTitle>
                            </CardHeader>

                            <CardBody>
                                <div className="info mb-4">
                                    <div className="info__item">
                                        <span>工事番号</span>
                                        <span/>
                                    </div>

                                    <div className="info__item">
                                        <span>現場名</span>
                                        <span/>
                                    </div>
                                </div>

                                <GoogleMapPolygon
                                    idBoxMap="map"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default Edit;